<template>
  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">{{ name }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact.entreprises', params: { contactId: this.contact.id } }">Entreprises</a>
        </div>
        <h1>{{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
        <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
      </div>
    </div>
    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'editContact.entreprises', params: { contactId: contact.id }}">Entreprises</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.emplois', params: { contactId: contact.id }}">Emplois</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.formations', params: { contactId: contact.id }}">Formations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.capes', params: { contactId: contact.id }}">CAPE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.cers', params: { contactId: contact.id }}">CER</a>
        </li>
      </ul>
    </div>
    <div class="card-block">
      <h2 class="card-title">Liste des entreprises</h2>
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Nom</th>
            <th class="hidden-sm-down">Siret</th>
            <th class="hidden-sm-down">Structure</th>
            <th class="hidden-sm-down">Statut de l'entrepreneur</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="company of companies | orderBy 'name' ">
            <td>{{ company.name }}</td>
            <td class="hidden-sm-down">{{ company.siret }}</td>
            <td class="hidden-sm-down">{{ structure_types[company.structure_id] }}</td>
            <td class="hidden-sm-down">{{ company.statut_entrepreneur }}</td>
            <td class="text-xs-right">
              <button class="btn btn-primary" v-on:click="edit(company)">Modifier</button>
              <button class="btn btn-warning" v-on:click="remove(company)">Supprimer</button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="6">
              <button class="btn btn-primary" v-on:click="create(company)">Créer une entreprise</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="card-block" v-if="company">
      <hr>
      <h2 class="card-title">{{ editionName }}</h2>
      <validator name="validator">
        <form novalidate>
          <div class="form-group">
            <label for="name">Nom de l'entreprise</label>
            <input class="form-control"
              id="name"
              type="text"
              v-model="company.name"
              v-validate:name="{required: required, maxlength: 90}"
            >
            <small class="form-text text-danger" v-if="$validator.name.required">Vous devez indiquer un nom</small>
            <small class="form-text text-danger" v-if="$validator.name.maxlength">Trop long</small>
          </div>
          <div class="form-group">
            <label for="creation_date">Date de création de l'entreprise</label>
            <!--
            <date-picker :time.sync="company.creation_date" :option="datepickerOptions" ></date-picker>
            -->
            <input
              id               = "creation_date"
              class            = "form-control"
              type             = "text"
              v-model          = "company.creation_date"
            >
          </div>
          <div class="form-group">
            <label for="radiation_date">Date de radiation de l'entreprise</label>
            <!--
            <date-picker :time.sync="company.ratification_date" :option="datepickerOptions" ></date-picker>
            -->
            <input
              id               = "ratification_date"
              class            = "form-control"
              type             = "text"
              v-model          = "company.ratification_date"
            >
          </div>
          <div class="form-group">
            <label for="structure_types">Structure juridique de l'entreprise</label>
            <select id="structure_types" class="form-control" v-model="company.structure_id">
              <option v-for="(index, value) in structure_types" :value="index">{{ value }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="statut_entrepreneur">Statut de l'entrepreneur</label>
            <select id="statut_entrepreneur" class="form-control" v-model="company.statut_entrepreneur_id">
              <option value=""></option>
              <option v-for="(index, value) in statut_entrepreneurs" v-if="value.length" :value="index">{{ value }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="name">Si autre, précision : </label>
            <input class="form-control"
              id="statut_entrepreneur_precision"
              type="text"
              v-model = "company.statut_entrepreneur_precision"
            >
          </div>
          <div class="form-group">
            <label for="siret">Numéro SIRET</label>
            <input class="form-control"
              id="siret"
              type="text"
              v-model="company.siret"
            >
          </div>
          <div class="form-group">
            <label for="ape">Code APE</label>
            <input class="form-control"
              id="ape"
              type="text"
              v-model="company.ape"
            >
          </div>
          <!--<div class="form-group">-->
            <!--<label for="statut_entrepreneur">Statut de l'entrepreneur</label>-->
            <!--<input class="form-control"-->
              <!--id="statut_entrepreneur"-->
              <!--type="text"-->
              <!--v-model="company.statut_entrepreneur"-->
            <!--&gt;-->
          <!--</div>-->
          <hr>
          <div class="form-group">
            <label for="tax_regimes">Régime fiscal</label>
            <div v-for="element in company.tax_regimes_list">
              <switch :value.sync="element.selected">{{ element.name }}</switch>
            </div>
          </div>
          <hr>
          <div class="form-group">
            <label for="welfare_regimes">Régime social</label>
            <div v-for="element in company.welfare_regimes_list">
              <switch :value.sync="element.selected">{{ element.name }}</switch>
            </div>
          </div>
          <hr>
          <div class="form-group">
            <switch id="accre" :value.sync="company.accre">ACCRE</switch>
          </div>
          <hr>
          <div class="form-group">
            <!--label for="financement">Financement</label!-->
            <switch id="financementcheck" :value.sync="company.financementcheck">Financement</switch>
            <input class="form-control"
              id="financement"
              type="text"
              v-model="company.financement"
            >
          </div>
          <hr>
          <div class="form-group">
            <switch :value.sync="company.conventional_objective">Objectif conventionné</switch>
          </div>
          <div class="text-xs-right">
            <button class="btn btn-warning" v-on:click.prevent="cancel()">Annuler</button>
            <button class="btn btn-primary" v-on:click.prevent="save()" :class="{ disabled: !$validator.valid }">Enregistrer</button>
          </div>
        </form>
      </validator>
    </div>
  </div>
</template>
<script>
    import moment from 'moment'

    // Options for datepicker
    import { datepickerOptions } from 'src/options/date'

    // Required for datepicker
    import datePicker from 'vue-datepicker/vue-datepicker-1.vue'

    import { Switch } from 'mint-ui'

    // Vuex
    import { getCompanies, addCompany, editCompany, deleteCompany } from 'src/vuex/actions/companiesActions'
    import { getContact } from 'src/vuex/actions/contactActions'
    import { getStructureTypes } from 'src/vuex/actions/structureTypesActions'
    import { getStatutEntrepreneurs } from 'src/vuex/actions/statutEntrepreneursActions'
    import { getTaxRegimes } from 'src/vuex/actions/taxRegimesActions'
    import { getWelfareRegimes } from 'src/vuex/actions/welfareRegimesActions'

    import {
      contact,
      companies,
      companiesRequestError as requestError,
      structureTypes as originStructureTypes,
      statutEntrepreneurs as originStatutEntrepreneurs,
      taxRegimes,
      welfareRegimes
    } from 'src/vuex/getters'

    export default{
      vuex: {
        getters: {
          companies,
          requestError,
          contact,
          originStructureTypes,
          originStatutEntrepreneurs,
          taxRegimes,
          welfareRegimes
        },
        actions: {
          getContact,
          getCompanies,
          addCompany,
          editCompany,
          deleteCompany,
          getStructureTypes,
          getStatutEntrepreneurs,
          getTaxRegimes,
          getWelfareRegimes
        }
      },
      validators: {
        list: function (val) {
          return /^[1-9]+$/.test(val)
        }
      },
      data () {
        return {
          isHidden: true,
          company: null,
          companyUpdate: null,
          datepickerOptions,
          structure_types: [],
          statut_entrepreneurs: [],
          s_types: [],
          taxRegimesList: [],
          welfareRegimesList: []
        }
      },
      computed: {
        name: function () {
          if (!Array.isArray(this.contact)) {
            return this.contact.leader_firstname + ' ' + this.contact.leader_lastname
          }
        },
        breadcrumb: function () {
          return [
            { link: '/', label: 'Accueil' },
            { link: '/contact', label: 'Gestion des participants' },
            { link: { name: 'editContact', params: { contactId: this.contact.id } }, label: this.contact.leader_firstname + ' ' + this.contact.leader_lastname },
            { link: { name: 'editContact.entreprise', params: { contactId: this.contact.id } }, label: 'Entreprise' }
          ]
        },
        editionName: function () {
          return (this.company !== null && Number.isInteger(this.company.id)) ? 'Edition' : 'Création'
        }
      },
      /*
      watch: {
        'taxRegimes': function () {
          if (this.company !== null && this.company.tax_regimes !== undefined) {
            this.updateTaxRegimesList()
          }
        }
      },*/
      /* Define the used methods */
      methods: {
        edit: function (company) {
          company = this.updateTaxRegimesList(company)
          company = this.updateWelfareRegimesList(company)
          this.company = JSON.parse(JSON.stringify(company))
          this.companyUpdate = company
          // this.updateTaxRegimesList()
          // this.updateWelfareRegimesList()
        },
        remove: function (company) {
          this.deleteCompany(company)
        },
        create: function () {
          this.company = {}
          this.companyUpdate = null
          this.taxRegimesList = []
          this.welfareRegimesList = []
          this.company = this.updateTaxRegimesList(this.company)
          this.company = this.updateWelfareRegimesList(this.company)
          // this.updateTaxRegimesList()
          // this.updateWelfareRegimesList()
        },
        cancel: function () {
          this.company = {}
          this.companyUpdate = null
        },
        save: function () {
          // this.company.tax_regimes = this.taxRegimesList
          // this.company.welfare_regimes = this.welfareRegimesList
          if (typeof (this.company.creation_date) === 'undefined' || this.company.creation_date === null || this.company.creation_date === '' || this.company.creation_date === 'undefined' || this.company.creation_date === 'Invalid date') {
            this.company.creation_date = ''
          } else {
            this.company.creation_date = moment(this.company.creation_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
          }
          if (typeof (this.company.ratification_date) === 'undefined' || this.company.ratification_date === null || this.company.ratification_date === '' || this.company.ratification_date === 'undefined' || this.company.ratification_date === 'Invalid date') {
            this.company.ratification_date = ''
          } else {
            this.company.ratification_date = moment(this.company.ratification_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
          }
          this.company.tax_regimes = this.company.tax_regimes_list
          this.company.welfare_regimes = this.company.welfare_regimes_list
          if (this.company !== null) {
            if (Number.isInteger(this.company.id) === true) {
              this.editCompany(this.companyUpdate, this.company)
            } else {
              this.company.contact_id = this.contact.id
              this.addCompany(this.company)
              let contactId = this.contact.id
              let that = this
              setTimeout(function () { that.getCompanies(contactId) }, 1000)
            }

            if (this.requestError === false) {
              this.company = null
            }
          }
        },
        updateTaxRegimesList: function (company) {
          let list = []
          // let company = this.company
          this.taxRegimes.forEach(function (el) {
            el.selected = false
            if (Array.isArray(company.tax_regimes)) {
              company.tax_regimes.forEach(function (i) {
                // console.log('tax_regimes ' + i.id + ' VS ' + el.id)
                if (i.id === el.id || JSON.stringify(i.id) === JSON.stringify(el.id)) {
                  if (i.selected === null || i.selected === undefined || i.selected === true) {
                    el.selected = true
                  }
                }
              })
            }
            list.push(el)
          })
          this.taxRegimesList = list
          company.tax_regimes_list = list
          return company
        },
        updateWelfareRegimesList: function (company) {
          let list = []
          // let company = this.company
          this.welfareRegimes.forEach(function (el) {
            el.selected = false
            if (Array.isArray(company.welfare_regimes)) {
              company.welfare_regimes.forEach(function (i) {
                if (i.id === el.id || JSON.stringify(i.id) === JSON.stringify(el.id)) {
                  if (i.selected === null || i.selected === undefined || i.selected === true) {
                    el.selected = true
                  }
                }
              })
            }
            list.push(el)
          })
          this.welfareRegimesList = list
          company.welfare_regimes_list = list
          return company
        }
      },
      components: { 'date-picker': datePicker, Switch },
      ready () {
        let that = this
        this.getContact(this.$route.params.contactId)
        this.getCompanies(this.$route.params.contactId)

        this.getStructureTypes().then(function () {
          that.originStructureTypes.forEach(function (element) {
            that.structure_types[element.id] = element.name
          })
        })
        this.getStatutEntrepreneurs().then(function () {
          that.originStatutEntrepreneurs.forEach(function (element) {
            that.statut_entrepreneurs[element.id] = element.name
          })
        })
        this.getTaxRegimes()
        this.getWelfareRegimes()
      }
    }
</script>




// WEBPACK FOOTER //
// ContactEditEntreprises.vue?9908c248